module.exports = require("!!vue-loader!../../node_modules/_vue-markdown-loader@2.4.1@vue-markdown-loader/lib/markdown-compiler.js?raw!./start.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/start.md
// module id = cYpM
// module chunks = 0